module.exports = __webpack_public_path__ + "img/letter.54a3d862.png";